import { NoAccess, PageEmpty, PageHeader } from "@majitap/ui";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Construction } from "lucide-react";
import type { ReactNode } from "react";
import { allowed, type ConsoleItem } from "../nav";
import { meQuery } from "../session";

/**
 * A page the role may not open renders the no-access state in the shell (spec: never in the
 * shell, never a crash). The API checks too: this only keeps people off pages that would fail.
 */
export function Gated({ item, children }: { item: ConsoleItem; children: ReactNode }) {
  const { data: me } = useSuspenseQuery(meQuery);
  if (!me || !allowed(item.gate, me.permissions)) {
    return (
      <>
        <PageHeader title={item.label} />
        <NoAccess />
      </>
    );
  }
  return <>{children}</>;
}

/** A menu item whose page isn't built yet (each has its roadmap task). */
export function ComingSoon({ item }: { item: ConsoleItem }) {
  return (
    <>
      <PageHeader title={item.label} description={item.description} />
      <PageEmpty
        icon={<Construction />}
        title="Not in the console yet"
        description="This page is being built. Until it's here, do this work in the old mothership."
      />
    </>
  );
}
